type PlanYear = number | string | null | undefined;

// Step 4 is temporarily disabled for 2026 plans. Remove 2026 from this set to reactivate it.
const TEMPORARILY_DISABLED_RESULTS_STEP_YEARS: ReadonlySet<number> = new Set([2026]);

export const isSelfAssessmentResultsStepPaused = (selectedYear: PlanYear): boolean =>
  TEMPORARILY_DISABLED_RESULTS_STEP_YEARS.has(Number(selectedYear));

export const shouldShowSelfAssessmentResultsStep = (
  readOnlyMode: boolean | null | undefined,
  planApproved: boolean | null | undefined,
  selectedYear: PlanYear,
): boolean =>
  Boolean(readOnlyMode && planApproved && !isSelfAssessmentResultsStepPaused(selectedYear));
